import React, { useState, useEffect } from "react";
import Select from "react-select";
import PGAModelBuilderCalcTabCalculationSelect from "../PGAModelBuilderCalcTabs/PGAModelBuilderCalcTab/PGAModelBuilderCalcTabCalculationSelect";
import { useLazyLoadQuery, graphql } from "react-relay";
import PGAModelBuilderInput from "../PGAModelBuilderInput";
import PGAModelBuilderButton from "../PGAModelBuilderButton";

const GET_CALC_QUERY = graphql`
  query PGAModelBuilderNewCalcSelectGetCalcOptionsQuery {
    pgaModelCalcClassifications {
      id
      name
    }
  }
`;

export default function PGAModelBuilderNewCalcSelect({
  addCalcToModel,
  calcReloads,
}) {
  const [selectedClassification, setSelectedClassification] = useState(
    undefined
  );
  const [selectedCalculation, setSelectedCalculation] = useState(undefined);
  const [newCalcName, setNewCalcName] = useState("");

  useEffect(() => {
    setNewCalcName("");
    setSelectedClassification(undefined);
    setSelectedCalculation(undefined);
  }, [calcReloads]);

  const data = useLazyLoadQuery(GET_CALC_QUERY);

  function updateSelectedCalc(value) {
    setSelectedCalculation(value);
    setNewCalcName(value.label);
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        gridGap: "10px",
        gap: "10px",
        zIndex: 888,
      }}
    >
      <div style={{ width: "100%", flex: "2 2 0", zIndex: "3" }}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>
          Classification
          <Select
            options={data.pgaModelCalcClassifications.map((classification) => {
              return {
                value: classification.id,
                label: classification.name,
              };
            })}
            value={selectedClassification}
            onChange={(selected) => {
              setSelectedClassification(selected);
              setSelectedCalculation(undefined);
            }}
          />
        </label>
      </div>

      <div style={{ width: "100%", flex: "2 2 0", zIndex: "3" }}>
        <React.Suspense
          fallback={
            /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
            <label>
              Calculation
              <Select options={[]} />
            </label>
          }
        >
          <PGAModelBuilderCalcTabCalculationSelect
            selectedClassification={selectedClassification}
            selectedCalculation={selectedCalculation}
            setSelectedCalculation={updateSelectedCalc}
          />
        </React.Suspense>
      </div>

      <PGAModelBuilderInput
        type="text"
        placeholder="Name Your Calculation Here"
        onChange={(e) => {
          setNewCalcName(e.target.value);
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            addCalcToModel(newCalcName, selectedCalculation.value);
          }
        }}
        value={newCalcName}
      />

      <PGAModelBuilderButton
        style={{ backgroundColor: "#1d89ff", color: "white" }}
        onClick={() => addCalcToModel(newCalcName, selectedCalculation?.value)}
      >
        Add Calc to Model
      </PGAModelBuilderButton>
    </div>
  );
}
